import { Component, h, Element } from '@stencil/core';

@Component({
  tag: 'qumra-slider-item',
  styleUrl: 'qumra-slider-item.css',
  shadow: false,
})
export class QumraSliderItem {
  @Element() el: HTMLElement;

  componentDidLoad() {
    this.el.classList.add('swiper-slide');

  }
  render() {
    return (
      <slot></slot>
    );
  }
}